import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';

import { useLoyalty, usePrevious } from 'hooks';
import { viewTerms, viewPrivacyPolicy } from 'actions/order';
import Checkbox from 'components/Checkbox';
import { getDetail } from 'selectors/storage';
import { StyledCheckbox } from './styles';

const messages = defineMessages({
  termsAndConditionsLabel: {
    defaultMessage:
      'I have read and accept the <termsLink>Terms & Conditions</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
  },
  loyaltyLabel: {
    defaultMessage:
      'By checking this box, I agree to <link>wi-Q Technologies</link>, <privacyLink>Privacy Policy</privacyLink> and { vapianoTermsAndConditionsLink } terms and conditions. This is required to continue with my order.',
  },
});

const propTypes = {
  termsAccepted: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  viewTerms: PropTypes.func,
  viewPrivacyPolicy: PropTypes.func,
};

const TermsCheckbox = ({ termsAccepted, value, onChange, onBlur, viewTerms, viewPrivacyPolicy }) => {
  const [prevTermsAccepted] = usePrevious(termsAccepted);
  const { type } = useLoyalty();

  const termsAndConditionsLink = parts => (
    <a
      href="/terms_conditions"
      className="linkUnderlined"
      onClick={e => {
        e.preventDefault();
        viewTerms();
      }}
    >
      {parts}
    </a>
  );

  const privacyPolicyLink = parts => (
    <a
      href="/privacy_policy"
      className="linkUnderlined"
      onClick={e => {
        e.preventDefault();
        viewPrivacyPolicy();
      }}
    >
      {parts}
    </a>
  );

  useEffect(() => {
    if (prevTermsAccepted !== termsAccepted && termsAccepted === true) {
      onChange(termsAccepted);
      onBlur(termsAccepted);
    }
  }, [prevTermsAccepted, termsAccepted, onChange, onBlur]);

  return (
    <StyledCheckbox className="secondary-font">
      {type !== 'como' && (
        <>
          <Checkbox
            id="acceptsTerms"
            checked={value || termsAccepted === 'true'}
            onChange={event => {
              onChange(event.target.checked);
              onBlur(event.target.checked);
            }}
          >
            <FormattedMessage
              {...messages.termsAndConditionsLabel}
              values={{
                termsLink: termsAndConditionsLink,
                privacyLink: privacyPolicyLink,
              }}
            />
          </Checkbox>
        </>
      )}
      {type === 'como' && (
        <>
          <Checkbox
            id="acceptsTerms"
            checked={value || termsAccepted === 'true'}
            onChange={event => {
              onChange(event.target.checked);
              onBlur(event.target.checked);
            }}
          >
            <FormattedMessage
              {...messages.loyaltyLabel}
              values={{
                link: termsAndConditionsLink,
                privacyLink: privacyPolicyLink,
                vapianoTermsAndConditionsLink: (
                  <a
                    className="linkUnderlined"
                    href="https://app4mobilebiz.wpengine.com/business-end-user-terms-of-use.html"
                    target="_blank"
                  >
                    Vapiano UK
                  </a>
                ),
              }}
            />
          </Checkbox>
        </>
      )}
    </StyledCheckbox>
  );
};

TermsCheckbox.propTypes = propTypes;

export default connect(
  state => ({
    termsAccepted: getDetail(state, 'terms'),
  }),
  { viewTerms, viewPrivacyPolicy }
)(TermsCheckbox);
